import { Routes, Route } from 'react-router-dom';

import { extensionsRoutes } from './pages/Routes';
import Layout from './components/layout/Layout';
import LoginPage from './pages/Login/Login';
import HomePage from './pages/Home/Home';
import RequireAuth from './components/requireAuth/RequireAuth';
import Logout from './pages/Logout/Logout';
import ReportsPage from '@/pages/Reports/Reports';

function App({ isWeb }: { isWeb?: boolean }) {
  return (
    <Routes>
      <Route path={extensionsRoutes.Home} element={<Layout />}>
        {/* public routes */}
        <Route
          path={extensionsRoutes.Login}
          element={<LoginPage isWeb={isWeb} />}
        />

        {/* private routes */}
        <Route element={<RequireAuth />}>
          <Route path={extensionsRoutes.Home} element={<HomePage />} />
          <Route path={extensionsRoutes.Logout} element={<Logout />} />
          <Route path={extensionsRoutes.Reports}>
            <Route
              path={':sessionId'}
              element={<ReportsPage isWeb={isWeb} />}
            />
          </Route>
        </Route>

        {/* catch all */}
        <Route path="*" element={<LoginPage isWeb={isWeb} />} />
      </Route>
    </Routes>
  );
}

export default App;
